import React from 'react';

import {type RouteData} from '../types';
import {GROUP_PATHS} from './groupWorkspacePaths';

export const GROUP_WORKSPACE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: true,
      datadogViewName: 'Group',
    },
    exact: true,
    isPrivateRoute: false,
    path: GROUP_PATHS,
    RouteComponent: React.lazy(() => import('../../pages/GroupPage')),
  },
];
